import React, { useEffect, useState } from "react";
import "./contacts.css";
import clouds from "../../assets/images/chats/cloud.png";
import google1 from "../../assets/images/chats/google.png";
import outlook from "../../assets/images/chats/Outlook.png";
import axios from "axios";
import Loader from "../../components/styled-components/loader/loader";
import DEATH_API from "../../apis/death.api";
import AppleLogin from "react-apple-login";
import GoogleContacts from "react-google-contacts";
import { GoogleLogin } from '@react-oauth/google';
import { useGoogleLogin } from '@react-oauth/google';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import swal from "sweetalert";
import NewLoader from "../../components/styled-components/loader/NewLoader";
const clientId = "com.assetplanet.client.signin";
const scope = "name email";
const redirectURI = "https://stage.assetplanet.com/client/plan";
const state = "origin:web";
const ConnectAccount = (props) => {
  const { instance } = useMsal();
  const [loading, setLoading] = useState(false);
  const [jsonData, setJsonData] = useState([]);
  const [fileName, setFileName] = useState('No file chosen');
  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      console.log('Google login success:', tokenResponse);
      // Handle successful login
      if(tokenResponse && tokenResponse.access_token){
        fetchGoogleContacts(tokenResponse.access_token)
      }
      // fetchContacts(tokenResponse.access_token);
    },
    onFailure: (error) => {
      console.error('Google login failure:', error);
      // Handle login failure
    },
    scope:"https://www.googleapis.com/auth/contacts",
    // scope: "https://www.googleapis.com/auth/contacts.readonly",
  });
   
  const handleMslLogin = () => {
    console.log("heree in login");
    instance
      .loginPopup(loginRequest)
      .then((response) => {
        console.log("Token acquired:", response.accessToken);
        // fetchOutlookUserContacts(response.accessToken);
        fetchOutlookContacts(response.accessToken)
        // Use the access token as needed
      })
      .catch((error) => {
        console.error("Login failed:", error);
      });
  };
  const fetchGoogleContacts = async (token) => {
    try {
      setLoading(true);
      const response = await DEATH_API.getGoogleContacts({accessToken:token});
      if (response && response.data || response.status===200) {
        props.close();
      }
      if (response && response.status===400) {
        swal("Oops!",response.message,"error");
        props.close();

      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error initiating Google OAuth:", error);
    }
  };
  const fetchAppleContacts = async () => {
    try {
      setLoading(true);
      const response = await DEATH_API.getAppleContacts();
      if (response && response.data || response.status===200) {
        props.close();
      }
      if (response && response.status===400) {
        swal("Oops!",response.message,"error");
        props.close();

      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error initiating Google OAuth:", error);
    }
  };
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setFileName(file.name);
    const reader = new FileReader();

    reader.onload = () => {
      const csvData = reader.result;
      const lines = csvData.split('\n');
      const headers = lines[0].split(',');

      const data = lines.slice(1).map(line => {
        const values = line.split(',');
        return headers.reduce((obj, header, index) => {
          obj[header.trim()] = values[index] && values[index].trim();
          return obj;
        }, {});
      });

      setJsonData(data);
      console.log(data,"data")
      fetchContactsFile(data);
    };

    reader.readAsText(file);
  };
  const fetchContactsFile = async (data) => {
    try {
      setLoading(true);
      const response = await DEATH_API.importContactFile(data);
      if (response && response.data || response.status===200) {
        props.close();
      }
      if (response && response.status===400) {
        swal("Oops!",response.message,"error");
        props.close();

      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error ", error);
    }
  };
  // const fetchContacts = async (accessToken) => {
  //   try {
  //     const response = await fetch('https://people.googleapis.com/v1/people/me/connections?personFields=names,emailAddresses,phoneNumbers,addresses,birthdays,occupations,organizations,relations', {
  //       headers: {
  //         Authorization: `Bearer ${accessToken}`,
  //       },
  //     });
  
  //     if (response.ok) {
  //       const data = await response.json();
  //       console.log('User contacts:', data.connections);
  //       // Set your contacts state or handle the data accordingly
  //     } else {
  //       console.error('Failed to fetch contacts:', response.statusText);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching contacts:', error);
  //   }
  // };
  
 

  const fetchOutlookContacts = async (token) => {
    try {
      setLoading(true);
      const response = await DEATH_API.getOutlookContacts({accessToken:token});
      if (response && response.data || response.status===200) {
        props.close();
      }
      if (response && response.status===400) {
        swal("Oops!",response.message,"error");
        props.close();

      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error initiating Google OAuth:", error);
    }
  };
  // const fetchOutlookUserContacts = async (accessToken) => {
  //   try {
  //     const graphApiEndpoint = "https://graph.microsoft.com/v1.0/me/contacts";
  //     const response = await fetch(graphApiEndpoint, {
  //       headers: {
  //         Authorization: `Bearer ${accessToken}`,
  //       },
  //     });
  
  //     if (response.ok) {
  //       const contactsData = await response.json();
  //       console.log("User contacts:", contactsData.value);
  //     } else {
  //       console.error("Failed to fetch user contacts:", response.statusText);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching user contacts:", error);
  //   }
  // };
  // const responseCallback = (response) => {
  //   console.log("callbackresponse", response);
  // };
  // useEffect(() => {
  //   window.AppleID.auth.init({
  //     clientId,
  //     scope,
  //     redirectURI,
  //     state,
  //     usePopup: false,
  //   });
  //   document.addEventListener("AppleIDSignInOnSuccess", handleAppleSuccess);
  //   document.addEventListener("AppleIDSignInOnFailure", handleAppleFailure);
  //   return () => {
  //     document.removeEventListener(
  //       "AppleIDSignInOnSuccess",
  //       handleAppleSuccess
  //     );
  //     document.removeEventListener(
  //       "AppleIDSignInOnFailure",
  //       handleAppleFailure
  //     );
  //   };
  // }, []);
  // const handleAppleSuccess = (event) => {
  //   console.log("Success  in apple login", event);
  //   // Call your function to handle the successful sign-in
  //   handleAppleResponse(event.detail);
  // };
  // const handleAppleFailure = (event) => {
  //   console.log("Error ", event);
  //   // Handle failure here
  // };
  // const initiateGoogleOAuth = async () => {
  //   try {
  //     setLoading(true);
  //     const response = await DEATH_API.getGoogleIntialize();
  //     if (response && response.data) {
  //       handleGoogleSignIn(response.data);
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     console.error("Error initiating Google OAuth:", error);
  //   }
  // };
  // useEffect(() => {
  //   console.log("useeffetete", window.location);
  // }, [window.location]);
  // const handleGoogleSignIn = (auth) => {
  //   const width = 600;
  //   const height = 600;
  //   const left = (window.screen.width - width) / 2;
  //   const top = (window.screen.height - height) / 2;
  //   const features = `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,status=yes`;
  //   // Open the URL in a popup window
  //   const popup = window.open(auth, "_blank", features);
  //   console.log("Message received:", window, popup);
  //   // Add event listener to listen for messages from the popup window
  //   const checkPopupClosed = setInterval(() => {
  //     if (popup && popup.closed) {
  //       clearInterval(checkPopupClosed);
  //       console.log("Popup window closed");
  //       props.close();
  //     }
  //   }, 1000);
  //   window.addEventListener("message", (event) => {
  //     // Check if the message is from the popup window and contains the desired response
  //     console.log("Message received:", event);
  //     if (
  //       event.source === popup &&
  //       event.data === "contacts fetched successfully"
  //     ) {
  //       // Close the popup window
  //       popup.close();
  //     }
  //   });
  // };
  // const handleAppleResponse = async (response) => {
  //   console.log("responseresponse", response);
  //   try {
  //     setLoading(true);
  //     // Extract the authorization code from the response
  //     const { authorization } = response;
  //     // Make a request to your server to exchange the authorization code for tokens
  //     const tokenResponse = await axios.post("/apple/token", { authorization });
  //     // Extract the access token from the response
  //     const { access_token } = tokenResponse.data;
  //     // Make a request to fetch contacts using the access token
  //     const contactsResponse = await axios.get(`/apple/contacts`, {
  //       headers: { Authorization: `Bearer ${access_token}` },
  //     });
  //     // Handle the response containing contacts
  //     console.log("Contacts:", contactsResponse.data);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error("Error fetching contacts:", error);
  //     setLoading(false);
  //   }
  // };
  // const handleAppleError = (error) => {
  //   console.error("Apple Sign In Error:", error);
  //   // Handle error here
  // };

  return (
    <div style={{position:"relative"}}>
      <div className="connectContainer">
        <h1 className="contactsSubHeading" >Connect With</h1>

        <div className="connectButtons" onClick={() => handleMslLogin()}>
          <img src={outlook} alt="Outlook" />
          Outlook.com 365 contacts
        </div>
        <div className="connectButtons" 
          onClick={() => login()}
        // onClick={initiateGoogleOAuth}
        >
          <img src={google1} alt="Google" />
          Google Contacts
        </div>
        <div className="connectButtons" onClick={()=>{fetchAppleContacts()}}>
          <img src={clouds} alt="Cloud" />
          ICloud Contacts (mobile application only)
        { /* <AppleLogin
            clientId="com.assetplanet.client.signin"
            redirectURI="https://stage.assetplanet.com/client/plan"
            state="origin:web"
            scope="email name"
            usePopup={false}
            onSuccess={handleAppleResponse}
            onError={handleAppleError}
            render={({ onClick }) => (
              <div onClick={onClick}>ICloud Contacts</div>
            )}
            /> */}
        </div>
      </div>
      <div className="connectContainer" style={{ marginTop: "1rem" }}>
        <h1 className="contactsSubHeading">Import File</h1>
        <div className="connectButtons">
          <input
            id="file"
            type="file"
            name="file"
            className="inputUpload"
            onChange={handleFileUpload}
            style={{
              width: "80%",
              display: "none",
              marginRight: "10px",
            }}
           
            accept=".csv"
          />
          <label
            className="uploadLabel file"
            htmlFor="file"
            style={{ width: "100%" }}
          >
            <div
              className="fileBlock"
              id="filechose"
              style={{ marginRight: "10px" }}
            >
              {fileName} <img src={clouds} alt="fileIcon" />
            </div>
            <span className="fileButton">Browse</span>{" "}
          </label>
        </div>
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};
export default ConnectAccount;